/* eslint-disable react/display-name */
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const withLocation = (Component) => (props) => <Component {...props} location={useLocation()} />;

export const withNavigate = (Component) => (props) => <Component {...props} navigate={useNavigate()} />;
